/* eslint-disable no-console */
import { GenericErrorContainer, NotFoundContainer } from 'routes/errors';

function Error({ statusCode }: any) {
  if (statusCode === 404) {
    return <NotFoundContainer />;
  }

  return <GenericErrorContainer />;
}

Error.getInitialProps = ({ req, res, err }: any) => {
  // eslint-disable-next-line no-nested-ternary
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;

  console.error(
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    `Error.getInitialProps, Request: ${req?.method} ${req?.url}, Error: ${err?.message} ${err?.stack}`,
  );

  const title =
    statusCode === 404
      ? 'Sorry, page not found'
      : 'Sorry, we ran into a problem';

  return {
    err,
    statusCode,
    metadata: {
      title,
    },
  };
};

export default Error;
